import { useState } from "react";
import "./App.css";
import { Canvas2 } from "./Canvas";
import { Customizer2 } from "./Overlay";
import { useSnapshot } from "valtio";
import { state } from "./store";
import VideoComponent from "./VideoComponent";

export default function App() {
  const [showPOI, setShowPOI] = useState(true);
  const snap = useSnapshot(state);

  const handleDownload = async () => {
    setShowPOI(false);
    await new Promise((resolve) => setTimeout(resolve, 100));
    const link = document.createElement("a");
    link.setAttribute("download", "canvas.png");
    link.setAttribute(
      "href",
      document
        .querySelector("canvas")
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream")
    );
    link.click();
    await new Promise((resolve) => setTimeout(resolve, 100));
    setShowPOI(true);
  };

  return (
    <div className="App" style={{ height: "100vh" }}>
      <Canvas2 showPOI={showPOI} />
      <Customizer2 handleDownload={handleDownload} />
      {snap.showVideo && (
        <VideoComponent
          handleSkip={() => {
            state.showVideo = false;
          }}
        />
      )}
    </div>
  );
}
